import { useState, useEffect } from 'react';

export function useScrollSpy(sectionIds: string[], rootMargin = '-20% 0px -70% 0px') {
  const [activeId, setActiveId] = useState<string>('');

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        // 현재 보이는 섹션들 중 가장 위에 있는 것을 선택
        const visibleSections = entries
          .filter(entry => entry.isIntersecting)
          .sort((a, b) => {
            // boundingClientRect.top이 작을수록 더 위에 있음
            return a.boundingClientRect.top - b.boundingClientRect.top;
          });

        if (visibleSections.length > 0) {
          const topSection = visibleSections[0];
          const sectionId = topSection.target.id;
          const categoryId = sectionId.replace('section-', '');
          setActiveId(categoryId);
        }
      },
      {
        rootMargin,
        threshold: 0.1,
      }
    );

    // 모든 섹션 관찰 시작
    sectionIds.forEach(id => {
      const element = document.getElementById(`section-${id}`);
      if (element) {
        observer.observe(element);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, [sectionIds, rootMargin]);

  return activeId;
}
